import { render } from "./CampaignSimplePreview.vue?vue&type=template&id=47f681ee&scoped=true"
import script from "./CampaignSimplePreview.vue?vue&type=script&lang=js"
export * from "./CampaignSimplePreview.vue?vue&type=script&lang=js"

import "./CampaignSimplePreview.vue?vue&type=style&index=0&id=47f681ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47f681ee"]])

export default __exports__